import { PropsWithChildren, useState } from "react";

import dynamic from "next/dynamic";

import {
  DISABLED_WORKSPACE,
  ProWorkspaceContext,
  ProWorkspaceContextValue,
} from "@/features/pro-buyer-workspaces/components/workspace-context";
import { useWorkspaceAccess } from "@/features/pro-buyer-workspaces/hooks/useWorkspaceAccess";

const WorkspaceEngine = dynamic(
  () =>
    import("@/features/pro-buyer-workspaces/components/WorkspaceEngine").then(
      module => module.WorkspaceEngine
    ),
  { ssr: false }
);

/**
 * WHO-6629. Evaluates the gates and the access ONCE per page (a search page
 * has 24+ hearts). Mounted in `_app`, so it stays this small: outside the
 * gate it provides DISABLED_WORKSPACE (every action a no-op) and loads
 * nothing else, and the site behaves and weighs exactly as today. Inside, the
 * lazily loaded WorkspaceEngine fills the context and owns the overlays; until
 * its chunk has arrived the hearts simply work as today.
 */
export const ProWorkspaceProvider = ({ children }: PropsWithChildren) => {
  const access = useWorkspaceAccess();
  const [engine, setEngine] = useState<ProWorkspaceContextValue | null>(null);
  const value = access.enabled && engine ? engine : DISABLED_WORKSPACE;

  return (
    <ProWorkspaceContext.Provider value={value}>
      {children}
      {access.enabled && (
        <WorkspaceEngine canEdit={access.canEdit} onChange={setEngine} />
      )}
    </ProWorkspaceContext.Provider>
  );
};
